export default __webpack_public_path__ + "static/media/1102009454_univ_lsr_xl.64a03d35.jpg";